import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';

import { Api } from '../../../../api';
import { AppState } from '../../../../store/models/app-state';
import { DemandDetail } from '../models/demand-detail';
import { DemandDetailFormValues } from '../models/demand-detail-form-values';

export const DEMAND_DETAIL_CLEARED = 'DEMAND_DETAIL_CLEARED';
export const DEMAND_DETAIL_DECLINED = 'DEMAND_DETAIL_DECLINED';
export const DEMAND_DETAIL_PATCH_FAILED = 'DEMAND_DETAIL_PATCH_FAILED';
export const DEMAND_DETAIL_PATCH_SUCCESS = 'DEMAND_DETAIL_PATCH_SUCCESS';
export const DEMAND_DETAIL_PATCH_STARTED = 'DEMAND_DETAIL_PATCH_STARTED';
export const DEMAND_DETAIL_RECEIVED = 'DEMAND_DETAIL_RECEIVED';
export const DEMAND_DETAIL_REQUESTED = 'DEMAND_DETAIL_REQUESTED';

const demandReceived = (demand: DemandDetail) => {
    return {
        type: DEMAND_DETAIL_RECEIVED,
        demand,
    };
};

export const updateSessionStorage = (demandDetailAccount: DemandDetailFormValues) => {
    return (dispatch: Dispatch, getState: () => AppState) => {
        const demand = getState().demands.detail.demand;

        if (!demand) {
            return;
        }

        const storageString = sessionStorage.getItem('cacheData');
        const currentCache: { [id: number]: DemandDetailFormValues } = storageString ? JSON.parse(storageString) : {};
        currentCache[demand.id] = demandDetailAccount;
        sessionStorage.setItem('cacheData', JSON.stringify(currentCache));
        dispatch({ type: DEMAND_DETAIL_CLEARED });
    };
};

export const fetchDemand = (demandId: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: DEMAND_DETAIL_REQUESTED });

        const response = await api.demand.DemandDetail.get(demandId);
        if (!response.success) {
            if (response.requestCanceled || response.errorCode === 404) {
                return;
            }
            throw response.error;
        }

        const demand = response.result;

        // FIXME: Enable again after checking what's going wrong
        // const sessionData = sessionStorage.getItem('cacheData');
        // if (sessionData) {
        //     const parsedSessionData: { [id: number]: Partial<DemandAccount> } = JSON.parse(sessionData);
        //     const cacheData = parsedSessionData?.[demand.id] ?? {};

        //     demand.demandAccounts[0] = {
        //         ...demand.demandAccounts[0],
        //         ...cacheData,
        //     };
        // }

        dispatch(demandReceived(demand));
    };
};

export const sendDemandAccount = (demandAccount: DemandDetailFormValues) => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: DEMAND_DETAIL_PATCH_STARTED });

        const demand = getState().demands.detail.demand;
        if (demand) {
            const response = await api.demand.DemandDetail.updateDemandAccount(demandAccount, demand.id);
            if (!response.success) {
                dispatch({ type: DEMAND_DETAIL_PATCH_FAILED });
                dispatch(Snackbar.enqueue(Snackbar.PoolNotification.error('app.snackbar.patchDemandAccountFailed')));
            }

            dispatch(Snackbar.enqueue(Snackbar.PoolNotification.success('app.snackbar.patchDemandAccountSuccess')));
            dispatch({ type: DEMAND_DETAIL_PATCH_SUCCESS });
        }
    };
};
